

/**
 * 通用 meta.title 文案
 */
export const ROUTER_TITLE = 'WPS 365 教育版- 一体化数字教育体验，专为教育打造的数字化解决方案-安全高效-协同教学办公-WPS 365 教育版官网';

// 价格页
export const PRICE_TITLE = 'WPS 365 教育版-WPS 365 教育版官网-正版WPS-在线文档-WPS云盘';

// WPS Office 2023 教育版首页
export const HOME_2023_TITLE = 'WPS Office 2023 教育版- 满足大中小学教育客户多样化教学办公需求，帮助您的机构简化工作、提升效率-WPS Office 2023 教育版官网';



